import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import User from 'flarum/common/models/User';
import Badge from 'flarum/common/components/Badge';
export default function () {
  extend(User.prototype, 'badges', function (badges) {
    if (this.anonymized()) {
      badges.add('anonymized', m(Badge, {
        label: app.translator.trans('flarum-gdpr.forum.badges.anonymized_user'),
        icon: "fas fa-user-secret",
        type: "anonymized"
      }));
    }
  });
}